<template>
  <div class="inner-graph-content" v-if="seizures">
    <Spinner :isLoading="isLoading" />
    <div class="graph-area">
      <div class="graph-top-area clearfix">
        <ul class="period-text-area clearfix">
          <li :style="$t('__locale') === 'en' ? 'margin-right: 10px; margin-top: 2px;' : ''">{{ $t('display_period_colon') }}</li>
          <li class="icon-prev">
            <a href="javascript:" @click="[![8].includes(filterTypeActive) ? onGetDataChartPrev(filterTypeActive) : null]">
              <img v-if="![8].includes(filterTypeActive)" src="/common/img/icon_date_prev.png" alt="" height="25">
              <img v-else src="/common/img/icon_date_disable.png" alt="" height="25" style="transform: rotate(180deg);">
            </a>
          </li>
          <li class="txt-period"><time v-if="filterTypeActive !==0">{{ dateFrom }} ~ </time>{{ dateEnd }}
            <span>（{{filterType[filterTypeActive]}}）</span>
          </li>
          <li class="icon-next">
            <a href="javascript:" @click="[displayIconNextDate && ![8].includes(filterTypeActive) ? onGetDataChartNext(filterTypeActive) : null]">
              <img v-if="displayIconNextDate && ![8].includes(filterTypeActive)" src="/common/img/icon_date_next.png" alt="" height="25">
              <img v-else src="/common/img/icon_date_disable.png" alt="" height="25">
            </a>
          </li>
        </ul>

        <ul class="period-btn-pos" v-if="isShowDisplayType">
          <li v-for="(type, index) in displayType" :key="index" @click="onChangeDisplayType(index)">
            <div :class="[index === displayTypeActive ? 'period-type-active' : 'period-type']"><a href="javascript:"><p>{{ type }}</p></a></div>
          </li>
        </ul>
        <ul class="graph-btn-pos clearfix">
          <li><div class="btn-graph"><a href="javascript:" @click="onShowCalendar()"><p><span class="icon-calendar">{{ $t('display_period_setting') }}</span></p></a></div></li>
          <li><div :class="[displayMethodActive === 0 ? 'btn-graph' : 'disable']"><a href="javascript:" @click="[displayMethodActive === 0 ? onExportPDF() : null]"><p><span class="icon-pdf">{{ $t('pdf_export') }}</span></p></a></div></li>
        </ul>
      </div>
      <div class="graph-type-area clearfix">
        <div class="type-ttl-pos">
          <p class="txt-type">{{ $t('period_setting_colon') }}</p>
        </div>
        <div class="type-btn-pos">
          <ul>
            <li v-for="(item, index) in filterType" :key="index">
              <div :class="[index === tempFilterTypeActive ? 'btn-type-active' : 'btn-type']">
                <a href="javascript:" @click="onGetDataChart(item, index)">
                  <p><span class="icon-calendar">{{ item }}</span></p>
                </a>
              </div>
            </li>
          </ul>
        </div>                        
      </div>

        <div class="graph-method-area clearfix" v-if="isShowDisplayMethod && displayTypeActive !== 2 ">
          <p class="method-ttl">{{ $t('display_method_colon') }}</p>
          <ul class="method-btn-pos">
            <li v-for="(type, index) in displayMethod" :key="index" @click="onChangeDisplayMethod(index)">
              <div :class="[index === displayMethodActive ? 'method-type-active' : 'method-type']"><a href="javascript:"><p>{{ type }}</p></a></div>
            </li>
          </ul>
        </div>
        <div class="graph-type-area clearfix">
          <div class="type-ttl-pos">
            <p class="txt-type">{{ $t('seizures_type_colon') }}</p>
          </div>
          <div class="type-btn-pos" style="width: calc(100% - 205px);">
            <ul>
              <li v-for="(type, index) in seizureType" :key="index" @click="onChangeSeizureType(index, type); trackingChangeSeizureType(type.index)">
                <div :class="[seizuresTypeActive.includes(index) ? 'btn-type-active' : 'btn-type']" style="display: flex;" v-if="type.index !== 0">
                  <a href="javascript:;">
                    <p style="display: flex;">
                      <span :class="[seizuresTypeActive.includes(index) ? 'icon-checkbox-checked' : 'icon-checkbox-uncheck']" style="margin-top: 3px;"></span>
                      <span v-if="type.index !== 7">
                        {{ shortcatLabel[type.index - 1] + ' ' }}
                      </span>
                      <span style="height: 15px; margin: 3px 5px 0px 5px;">
                        <canvas v-if="type.index !== 6" :id="`canvas${legends[index - 1].index}`" width="15" height="15" style="border-radius: 50%"></canvas>
                        <canvas v-else width="15" height="15" :style="{backgroundColor: legends[5].pattern, borderRadius: '50%'}"></canvas>
                      </span>
                      <span v-if="type.name">
                        {{ type.name }}
                      </span>
                    </p>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <div class="type-btn-pos" style="max-width: 120px;">
            <ul style="float: right;">
              <li>
                <div class="" :class="[isSelectAll ? 'btn-type-all' : 'btn-type-all-active' ]" style="margin-right: 0;"  @click="onChangeSeizureType(0, seizureType[0]); trackingChangeSeizureType(0)">
                  <a href="javascript:">
                    <p>
                      <span class="icon-calendar">
                        {{ isSelectAll ? $t('unselect_all') : $t('all__3c') }}
                      </span>
                    </p>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="graph-type-area clearfix">
          <div class="type-ttl-pos">
            <p class="txt-type">{{ $t('number_of_seizures') }}</p>
          </div>
          <div class="type-btn-pos">
            <div style="float: right;margin-right: 0; display: flex;">
              <p class="txt-type" style="margin-right: 20px;">発作回数の上限 : </p>
              <label>
                <input type="checkbox" @click="setDefaultSeizure" :checked="defaultSeizure" class="checkbox-input" :disabled="defaultSeizure"/>
                <span class="checkbox-parts" style="padding-left: 25px !important;padding-right: 10px;">自動</span>
              </label>
              <label>
                <input type="checkbox" @click="checkNumberSeizure" :checked="!defaultSeizure" class="checkbox-input" :disabled="!defaultSeizure"/>
                <span class="checkbox-parts" style="padding-left: 25px !important;padding-right: 5px;">上限指定</span>
              </label>
              <input type="text" name="" id="number-seizure" style="border: 1px solid #cccccc;width: 40px;" :disabled="defaultSeizure" v-model="numberSeiZure" v-on:keyup.enter="setNumberSeizure" inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');">
            </div>
          </div>
        </div>
        <div class="position-relative">
          <div class="graph-inner-area" @scroll="changeMedicineNamePosition(scrollBar, $event)" :style="[displayMethodActive == 1 ? { 'overflow-x': 'auto'} : { 'overflow-x': 'hidden'}]" style="position: relative;">
            <img :src="imageCanvas !== '' ? imageCanvas : ''" alt="" style="position: absolute; height: 400px;" :style="[(displayMethodActive === 1) ? { 'width': (chartData.labels.length * widthChartDesktop > baseWidth ? 
              setWidthDevice ? chartData.labels.length * widthChartIpad : chartData.labels.length * widthChartDesktop : baseWidth) + 'px'} : baseWidth ]" v-if="imageCanvas">
            <bar-chart
              v-resize="onResize"
              :chartData="chartData"
              :options="options"
              :plugins="plugins"
              ref="chart"
              id="chart-js"
              style="position: relative; height: 400px;"
              :style="[(displayMethodActive === 1) ? { 'width': (chartData.labels.length * widthChartDesktop > baseWidth ? 
              setWidthDevice ? chartData.labels.length * widthChartIpad : chartData.labels.length * widthChartDesktop : baseWidth) + 'px'} : baseWidth ]"
            >
            </bar-chart>
            <div v-show="[0,1,2].includes(filterTypeActive) || [1,2].includes(displayTypeActive) || displayMethodActive === 1">
              <div v-if="$store.state.auth.typeOfUser !== 'pharmacy'" id="camera" :style="{ width: tableWidth + 'px' }" style="display: flex; padding-top: 15px;">
                <div style="min-width: 100px"></div>
                <table id="show-camera-icon" class="show-table" :style="{ width: (tableWidth - 120)+'px', height: '20px' }">
                  <tr>
                    <CameraIcon
                      v-if="seizureData"
                      v-on:dataVideo="setDataVideo"
                      v-on:setLoading="setLoading"
                      :videosData="videosData"
                      :widthList="widthList"
                      :displayType="displayTypeActive"
                      :dateFrom="dateFrom"
                      :filterTypeActive="filterTypeActive"
                      :tableWidth="tableWidth">
                    </CameraIcon>
                  </tr>
                </table>
              </div>
              <div id="seizure-medication" :style="{ width: tableWidth + 'px' }" style="display: flex;">
                <div style="min-width: 100px">{{ $t('dosing_during_seizures') }}</div>
                <table id="show-seizure-medication" class="show-table" :style="{ width: (tableWidth - 120)+'px', height: '20px' }">
                </table>
              </div>
            </div>
            <div id="medication-taken-list"></div>
          </div>
          <div id="scrollbar" @scroll="updateScrollbar(scrollBelowChart)"><div id="innerScrollbar"><!--dummy text--></div></div>
        </div>
        <!-- <div style="display: inline-flex; margin-top: 10px;" class="container-type-seizure">
          <div style="display: inline-flex;" :style="{marginRight: setWidthDevice ? '10px' : '20px'}" v-for="(type, index) in legends" :key="index">
            <div v-if="type.index === 5" style="margin-right: 5px; height: 20px; width:40px;" :style="{backgroundColor: type.pattern}"></div>
            <div v-else style="margin-right: 5px; height: 20px; width:40px;">
              <canvas :id="`canvas${type.index}`" width="40" height="20"></canvas>
            </div>
            <div :style="{fontSize: setWidthDevice ? '15px' : null}" style="text-align: center; white-space: nowrap;">
              {{ type.name ? type.index !== null ? shortcatLabel[type.index] + ': ' + type.name : type.name : shortcatLabel[type.index] }}
            </div>
          </div>
        </div> -->
    </div>
    <b-modal id="modal-calendar" class="modal-content" content-class="modal-calendar-content" centered :hide-header="true" :hide-footer="true" style="width:60%">
      <div class="modal-inner">
        <div class="modal-period-area clearfix">
          <p class="m-period-txt">{{ $t('display_period_colon') }}</p>
          <ul class="m-btn-group">
            <li
              v-for="(type, index) in filterType"
              :key="index"
              @click="onFilterData(type, index)"
              style="cursor: pointer"
              :class="[index === tempFilterTypeActive ? 'm-period-btn is-active' : 'm-period-btn']"
            >
              {{ type }}
            </li>
          </ul>
        </div>
        <div class="modal-panel-group clearfix">
          <div class="m-panel is-show">
            <form>
              <div class="m-calendar-date-area clearfix">
                <p class="c-date-ttl">{{ $t('date_colon') }}</p>
                <input type="text"
                  :class="[isInvalidDate ? 'input-error' : '']"
                  class="date_val"
                  v-show="tempFilterTypeActive !== 0"
                  v-model="tempDateFrom"
                  disabled
                />
                <p class="c-date-txt" v-show="tempFilterTypeActive !== 0">～</p>
                <input
                  type="text"
                  class="date_val"
                  :class="[isInvalidDate ? 'input-error' : '']"
                  v-model="tempDateEnd"
                  :disabled="tempFilterTypeActive === 8"
                  placeholder="yyyy/mm/dd"
                />
                <div class="today-select-btn" @click="setToday()">{{ $t('today') }}</div>
                <div class="date-faq-btn" id="tooltip-button-variant" v-b-tooltip.top.v-danger.html="tooltipData" v-show="tempFilterTypeActive !== 0">?</div>
              </div>
              <p class="c-date-txt error-txt">{{ dateError }}</p>
              <div class="m-calendar-area" style="width: 75%">
                <calendar
                  ref="calendar"
                  @dayclick="dayClicked"
                  :attributes="datePickerAttr"
                  :columns="calendarLayout.columns"
                  :rows="calendarLayout.rows"
                  :is-expanded="calendarLayout.isExpanded"
                  :locale="$t('__locale')"
                  is-inline
                  v-model="tempDateEnd"
                  :max-date="new Date()"
                  :disabled-dates="[ new Date(this.tempDateEnd) ]"
                >
                  <div slot="header-title" slot-scope="{ year, month }">
                    <div>{{$t('year_month', {year: year, month: month})}}</div>
                  </div>
                  <a
                    slot="header-left-button"
                    class="ui-datepicker-prev ui-corner-all"
                    :title="'<'+$t('previous')">
                    <span class="ui-icon ui-icon-circle-triangle-w">&lt;{{ $t('previous') }}</span>
                  </a>
                  <a
                    slot="header-right-button"
                    class="ui-datepicker-next ui-corner-all"
                    :title="$t('next')+'>'">
                    <span class="ui-icon ui-icon-circle-triangle-e">{{ $t('next') }}&gt;</span>
                  </a>
                </calendar>
              </div>
              <div class="modal-btn-area clearfix">
                <div class="btn-base pos-left"><a href="javascript:" @click="onGetData()" class="modal-close"><p>{{ $t('ok') }}</p></a></div>
                <div class="btn-cancel pos-right"><a href="javascript:" @click="onHideCalendar()" class="modal-close"><p>{{ $t('cancel') }}</p></a></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-if="$store.state.auth.typeOfUser !== 'pharmacy'" id="video-list-modal-in-seizure-graph" centered :hide-header="true" :hide-footer="true" class="modal-content" @hidden="onModalSlideHidden" @show="OnModalShow">
      <div class="modal-inner">
        <div class="close-icon modal-close" @click="closeModalListVideo()"></div>
        <div class="modal-movie-area">
          <b-carousel
            id="carousel-video"
            v-model="slide"
            :interval="0"
            :controls="videosShow.length > 1 ? true : false"
            background="#ffff"
            no-wrap
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide v-for="(video, id) in videosShow" :key="id">
              <div><p class="movie-date-txt"> {{ convertToJPTime(video.create_date) }}</p></div>
              <div class="bg-dark" ref="videoPlayerSlider">
                <LazyVideo :src="video.video_access_url" :attrs="{controls: false}" width="100%" height="400" />
              </div>
              <div class="movie-icon" :ref="'movie-icon'+id" @click="onPlayVideoSlider(id)"></div>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-exceed-time"
      centered
      :hide-header="true"
      :hide-footer="true"
      class="modal-content"
    >
      <div class="modal-inner">
        <p class="modal-txt-error mb50">
          データ量が多いためタイムアウトしました。期間を絞って検索してください。
        </p>
        <div class="btn-base pos-center">
          <a href="javascript:;" class="modal-close" @click="handleModal">
            <p>{{ $t("ok") }}</p>
          </a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  // type : [0, 1, 2, 3, 4, 5] => [date, week, month, 3 month, 6 month, year]
  import BarChart from './BarChart.js'
  import Spinner from "@/js/components/Spinner"
  import CameraIcon from "./CameraIcons"
  import moment from 'moment'
  moment.suppressDeprecationWarnings = true
  import { BModal, VBModal, BButton, VBTooltip, BCarousel, BCarouselSlide } from 'bootstrap-vue'
  import { mapState, mapGetters } from 'vuex'
  import Calendar from 'v-calendar/lib/components/calendar.umd'
  import { correctColumnWidthData, makeMedicineBarForMedicineAmount, getInfoAndBasicInfo, getMonthBetweenDate, subLabelYearMonth } from "@/js/commons/commons"
  import { seizureColor, defaultDatasets, otherPattern } from '@/js/commons/chartConfig'
  const today = moment().format('YYYY/MM/DD')
  import { videoPlayer } from 'vue-video-player'
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
  import Chart from 'chart.js'

  export default {
    directives: { BModal, VBModal, BButton, VBTooltip, BCarousel, BCarouselSlide },
    components: {
      BarChart,
      BModal,
      BButton,
      Spinner,
      VBTooltip,
      Calendar,
      CameraIcon,
      BCarousel,
      BCarouselSlide,
      videoPlayer,
    },
    props: {
      isLoadedBasicInfo: {
        type: Boolean,
        required: true
      },
      isExportChartPDF: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        filterTypeBeforeTimeOut: null,
        tempDateEndBeforeTimeOut: null,
        defaultSeizure: true,
        numberSeiZure: null,
        tempValueInTooltips: 0,
        tempStartDatasetIndex: 0,
        firstLoad: true,
        chartData: {
          labels: [],
          datasets: [],
          temp_labels: [],
          labels2: [],
          scroll: null,
        },
        options: {
          normalized: true,
          scales: {
            xAxes: [{
              stacked: true,
              gridLines: {
                color: "rgba(0, 0, 0, 0)"
              }
            }],
            yAxes: [{
              stacked: true,
              afterFit: function(scaleInstance) {
                scaleInstance.width = 100
              },
              ticks: {
                beginAtZero: true,
                precision: 0,
                suggestedMax: 5
              }
            }]
          },
          tooltips: {
            mode: 'index',
            position: 'custom',
            callbacks: {
              label: (tooltipItem, data) => {
                return this.formatLabelInTooltip(tooltipItem, data)
              },
              labelTextColor: (context) => {
                return '#333333'
              },
              title: (tooltipItem, data) => {
                return this.formatTitleTooltips(tooltipItem, data)
              },
            },
            backgroundColor: '#fff',
            titleFontColor: '#333333',
            titleFontStyle: 'normal',
            borderColor: '#FF86A0',
            borderWidth: 1,
            bodySpacing: 6,
            xPadding: 10,
            yPadding: 10,
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          layout: {
            padding: {
              bottom: 15,
              right: 20,
            },
          },
          onHover : (event, activeElements) => {
            if (activeElements.length > 0) {
              if (this.imageCanvas !== '' ) {
                setTimeout(() => {
                  this.imageCanvas = ''
                }, 200);
              }
            }
          }
        },
        plugins: [subLabelYearMonth],
        datePickerAttr: [
          {
            key: 'today',
            order: 1,
            highlight: {
              color: 'pink',
              contentClass: 'todayHighlight',
            },
            dates: new Date()
          },
          {
            order: 2,
            highlight: {
              color: 'yellow',
              contentClass: 'chooseDateHighlight'
            },
            dates: null
          },
          {
            highlight: {
              color: 'red',
              fillMode: 'none',
              contentClass: 'sundayHighlight',
            },
            contentStyle: {
              color: 'red',
            },
            dates: { weekdays: 1 }
          },
          {
            highlight: {
              color: 'blue',
              fillMode: 'none',
              contentClass: 'saturdayHighlight',
            },
            contentStyle: {
              color: 'white',
            },
            dates: { weekdays: 7 }
          },
        ],
        currentDate: today,
        dateFrom: moment(new Date(today)).subtract(1, 'months').format('YYYY/MM/DD'),
        dateEnd: today,
        tempDateFrom: moment(new Date(today)).subtract(1, 'months').format('YYYY/MM/DD'),
        tempDateEnd: today,
        seizureType: null,
        seizureTypeActive: 0,
        seizuresTypeActive: [],
        displayMethod: [this.$t('summary'), this.$t('scroll')], //scroll or not
        displayMethodActive: 0,
        isShowDisplayMethod: false,
        displayType: [this.$t('by_day'), this.$t('by_week')], // by day or by week or by month
        displayTypeActive: 0,
        isShowDisplayType: false,
        filterType: [
          this.$t('one_day'), 
          this.$t('one_week'), 
          this.$t('one_month'), 
          this.$t('three_months'), 
          this.$t('six_months'), 
          this.$t('one_year'), 
          this.$t('three_year'),
          this.$t('five_year'),
          this.$t('all_periods')
        ],
        filterTypeActive: 2,
        tempFilterTypeActive: 2,
        isLoading: false,
        tableWidth: null,
        baseWidth: null,
        iconSize: '15px',
        pdfList: null,
        today,
        isInvalidDate: false,
        tooltipData: { title: this.$t('title_tooltip_data_patient_chart') },
        dateError: '',
        shortcatLabel: ['A', 'B', 'C', 'D', 'E', 'F'],
        widthList: null,
        setWidthDevice : false,
        widthChartIpad : 28,
        widthChartDesktop : 30,
        activePage: 'graph',
        selectedDate: '',
        videosData: [],
        videosShow: [],
        slide: 0,
        sliding: null,
        displayIconNextDate: false,
        isSelectAll: true,
        scrollBelowChart : true,
        scrollBar : true,
        imageCanvas: '',
        dateFromAllPeriod: '',
        minDate: ''
      }
    },
    computed: {
      ...mapState({
        seizures: state => state.patient.seizures,
        errorMsg: state => state.patient.errorMsg,
        otpAccessToken: state => state.otp.otpAccessToken,
        medicineColors: state => state.medicineColor.medicineColors,
        videos: state => state.patient.videos,
        info: state => state.patient.info,
        viewedHistories: state => state.patient.viewedHistories,
        medicines: state => state.medicine.medicines
      }),
      ...mapGetters({
        shortcats: 'patient/shortcats'
      }),
      calendarLayout() {
        return this.$screens(
          {
            default: {
              columns: 1,
              rows: 1,
              isExpanded: true,
            },
            lg: {
              columns: 2,
              rows: 1,
              isExpanded: true,
            },
          },
        )
      },
      seizureData() {
        if (this.seizures.seizure_data) return this.seizures.seizure_data
        return null
      },
      legends() {
        const legendArr = []
        this.shortcats.map((shortcat) => {
          const index = defaultDatasets.findIndex((item) => item.index === shortcat.shortcat_index)
          legendArr.push({
            index: defaultDatasets[index].index,
            name: shortcat.shortcat_name,
            pattern: defaultDatasets[index].backgroundColor
          })
        })
        legendArr.push({ index: null, name: this.$t('others'), pattern: otherPattern })
        return legendArr
      }, 
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    async mounted () {
      const isSafariIpad = navigator.userAgent.match(/iPad/i) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      if (isSafariIpad  || navigator.userAgent.match(/Tablet/i)) {
        this.setWidthDevice = true
      } else {
        this.setWidthDevice = false
      }
      if(!this.$route.params.childId){
        let params = {
          one_time_access_key: this.otpAccessToken,
          from_date: this.dateFrom,
          to_date: this.dateEnd
        }
        await this.$store.dispatch("patient/getSeizures", { params: params })
        await this.$store.dispatch("medicine/getMedicines", { params: params })
      } else {
        let params = {
          from_date: this.dateFrom,
          to_date: this.dateEnd,
          childId: this.$route.params.childId,
          typeOfUser: this.$store.state.auth.typeOfUser
        }
        //add property pharmacy_user_id if use is pharmacy
        if (this.$store.state.auth.typeOfUser === 'pharmacy') {
          params.pharmacy_user_id = this.$store.state.auth.doctorInfo.id
        }
        await this.$store.dispatch("patient/getSeizures", { params: params })
        await this.$store.dispatch("medicine/getMedicines", { params: params })
      }
      await this.$store.dispatch("medicineColor/getMedicineColors")
      await this.$store.dispatch("medicineShortcut/getMedicineShortcuts")
      // this.legends.forEach(legend => {
      //   if (legend.index !== 5) {
      //     const canvasId = 'canvas' + legend.index
      //     var c = document.getElementById(canvasId)
      //     var ctx = c.getContext("2d")
      //     ctx.rect(0, 0, 40, 20)
      //     ctx.fillStyle = legend.pattern
      //     ctx.fill()
      //   }
      // })
      const seizureType = this.shortcats.map((item) => {
        return {
          name: item.shortcat_name,
          index: item.shortcat_index + 1
        }
      })
      seizureType.unshift({ name: this.$t('all__3c'), index: 0 })
      seizureType.push({ name: this.$t('others'), index: 7 })
      // Default is select all seizure type
      seizureType.forEach((item, index) => {
        if (index !== 0) {
          if (!this.seizuresTypeActive.includes(index)) this.seizuresTypeActive.push(index)
        }
      })
      this.seizureType = seizureType
      await this.setChartData()
      this.updateScrollbar()
      this.isShowDisplayType = true
      this.baseWidth = parseInt(document.getElementById("bar-chart").style.width, 10)
      this.legends.forEach(legend => {
        if (legend.index !== 5) {
          const canvasId = 'canvas' + legend.index
          var c = document.getElementById(canvasId)
          var ctx = c.getContext("2d")
          ctx.rect(0, 0, 40, 20)
          ctx.fillStyle = legend.pattern
          ctx.fill()
        }
      })
      if (this.seizures.min_date) {
        this.minDate = this.seizures.min_date
      }

      Chart.Tooltip.positioners.custom = function(elements, eventPosition) {
      /** @type {Chart.Tooltip} */
      // var tooltip = this;
      /* ... */
      return {
        x: eventPosition.x,
        y: eventPosition.y
      };
      }
    },
    methods: {
      updateScrollbar(isHtmlCall = false) {
        const scrollbar = document.getElementById('scrollbar')
        const graphInnerArea = document.getElementsByClassName('graph-inner-area')[0]
        scrollbar.getElementsByTagName('*')[0].style.width = document.getElementById('chart-js').style.width
        if (isHtmlCall) {
          this.scrollBar = false;
          graphInnerArea.scrollLeft = scrollbar.scrollLeft;
        }
        $('#scrollbar').mousedown((e) => {
          this.scrollBelowChart = true;
          this.scrollBar = false;
        });
      },
      setDataVideo(val) {
        this.activePage = val.page
        this.selectedDate = val.date
      },
      changeMedicineNamePosition(isHtmlCall = false, event) {
        $('.graph-inner-area').mousedown((e) => {
          this.scrollBelowChart = false;
          this.scrollBar = true;
        });
        if (event.target.scrollLeft < 100) {
          this.setLeftForClass('chart-medicine-name', 120 - event.target.scrollLeft)
        } else {
          this.setLeftForClass('chart-medicine-name', 20)
        }
        // 100 is graph left distance, 20 is padding left
        if ((this.scrollBelowChart && this.scrollBar && isHtmlCall) === true) {
          this.scrollBelowChart = false
        }
        if (isHtmlCall) {
          const scrollbar = document.getElementById('scrollbar')
          $('.graph-inner-area').mouseup((e) => {
            this.scrollBelowChart = true;
          });
          const graphInnerArea = document.getElementsByClassName('graph-inner-area')[0]
          scrollbar.getElementsByTagName('*')[0].style.width = document.getElementById('chart-js').style.width
          scrollbar.scrollLeft = graphInnerArea.scrollLeft;
        }
      },
      setLeftForClass(className, value) {
        var elements = document.getElementsByClassName(className);
        for(var i = 0; i < elements.length; i++) {
          elements[i].style.left = value + "px";
        }
      },
      getMedicineColor(medicineName) {
        const medicineColor = this.medicineColors.find((item) => item.medicine_name === medicineName)
        if (medicineColor) {
          return medicineColor.dr_site_color_bold
        }
        return '#FF89C0'
      },
      onExportPDF() {
        const event = { event: this.$t('pdf_export'), event_category: this.$t('patient_information'), event_label: this.$t('pdf_export') }
        this.eventTracking(event)
        this.$bvModal.show('modal-pdf')
      },
      async exportPDF() {
        if(!this.isLoadedBasicInfo){
          this.isLoading = true
          await getInfoAndBasicInfo(this.info.id)
          this.isLoading = false
          this.$emit('setLoadedBasicInfo', true)
        }
        this.$bvModal.hide('modal-pdf')
        const data = {
          dateFrom: this.dateFrom,
          dateEnd: this.dateEnd,
          seizureTypeActive: this.seizureTypeActive,
          seizuresTypeActive: this.seizuresTypeActive,
          displayMethodActive: this.displayMethodActive,
          filterTypeActive: this.filterTypeActive,
          legends: this.legends,
          baseWidth: this.baseWidth,
          pdfList: this.pdfList,
          displayTypeActive: this.displayTypeActive,
          currentDateTime: this.convertToJPTime(moment().format('YYYY/MM/DD HH:mm')),
          medicineColors: this.medicineColors,
          child_name: this.$store.state.auth.typeOfUser !== 'pharmacy' ? this.info.name : this.viewedHistories.find((o) => { return o["child_id"] === this.$route.params.childId }).name
        }
        this.$store.dispatch('patient/setPDF', data)
        let routeData = this.$router.resolve({name: 'PDF'})
        this.$emit('setExportChartPDF', false)
        window.open(routeData.href, '_blank')
      },
      convertToJPTime(time) {
        const [year, month, dateTime] = time.includes('-') ? time.split('-') : time.split('/')
        const [date, times] = dateTime.split(' ')
        const data = this.$t('year_month_date_time', {year: year, month: month, date: date, times: times})
        return data
      },
      async setNumberSeizure() {
        if (this.numberSeiZure == 0) {
          this.numberSeiZure = 5
        }
        this.firstLoad = false
        await this.setChartData()
      },
      async setDefaultSeizure() {
        this.defaultSeizure = true
        await this.setChartData()
      },
      checkNumberSeizure() {
        this.defaultSeizure = false
        if (!this.numberSeiZure) {
          this.numberSeiZure = 5
        }
        this.setNumberSeizure()
      },
      onChangeSeizureType (index, type, checkSeizureTypeChange = true) {
        this.resetImg()
        if (index === 0) {
          if (this.seizureTypeActive === index && this.seizuresTypeActive.length !== 0) {
            this.seizuresTypeActive = []
            this.isSelectAll = false
          } else {
            this.seizureType.forEach((item, index) => {
              if (index !== 0) {
                if (!this.seizuresTypeActive.includes(index)) this.seizuresTypeActive.push(index)
              }
            })
          }
          this.isSelectAll = true
        }
        let chart = this.$refs.chart.$data._chart
        let datasets = chart.data.datasets
        if (checkSeizureTypeChange) {
          if (!this.seizuresTypeActive.includes(index) && index !== 0) {
            this.seizuresTypeActive.push(index)
          } else {
            this.seizuresTypeActive = this.seizuresTypeActive.filter(item => item !== index)
          }
        }

        // Updated seizuresTypeActive (button select all) when you check all seizure type then change seizureTypeActive = 0 (button select all active)
        if (this.seizuresTypeActive.length === this.legends.length) {
          this.isSelectAll = true
          this.seizureTypeActive = 0
        }
        else {
          this.seizureTypeActive = index
          this.isSelectAll = false
        }

        if (index === 0 && this.seizuresTypeActive.length === this.legends.length) {
          datasets.forEach(function(e, i) {
            chart.getDatasetMeta(i).hidden = null
          })
        } else {
          // let indexWithoutAll = index - 1
          // let alreadyHidden = (chart.getDatasetMeta(indexWithoutAll).hidden === null) ? false : chart.getDatasetMeta(indexWithoutAll).hidden
          // datasets.forEach(function(e, idx) {
          //   let meta = chart.getDatasetMeta(idx)
          //   if (idx !== indexWithoutAll) {
          //     if (!alreadyHidden) meta.hidden = meta.hidden === null ? !meta.hidden : null
          //     else if (meta.hidden === null) meta.hidden = true
          //   } else if (idx === indexWithoutAll) meta.hidden = null
          // })

          datasets.forEach((item, index) => {
            let indexWithout = index + 1
            if (this.seizuresTypeActive.includes(indexWithout)) chart.getDatasetMeta(index).hidden = null
            else chart.getDatasetMeta(index).hidden = true 
          })
        }
        chart.update()
        //
        datasets.every((e, index) => {
          if (chart.getDatasetMeta(index).hidden === null) {
            this.tempStartDatasetIndex = index
            return false
          } else {
            return true
          }
        })
        setTimeout(() => {
          this.convertCanvasToImage()
        }, 1000);
      },
      async onChangeDisplayType (index) {
        this.firstLoad = false
        const scrollbar = document.getElementById('scrollbar')
        if (index === this.displayTypeActive) return
        this.displayTypeActive = index
        if (index === 2) this.displayMethodActive = 0
        var ul = document.querySelector('.type-btn-pos ul');
        var lastThreeLiElements = ul.querySelectorAll('li:nth-last-child(-n+3)');            
        if (this.displayTypeActive === 0 && ![1,2].includes(this.filterType)) {
          lastThreeLiElements.forEach(function(li) {
            li.style.display = 'none';
          });
        } else {
          lastThreeLiElements.forEach(function(li) {
            li.style.display = 'block';
          });
        }
        if (this.displayMethodActive === 1) {
          scrollbar.style.display = 'block'
        } else {
          scrollbar.style.display = 'none'
        }
        await this.setChartData()
        this.updateScrollbar()
      },
      async onChangeDisplayMethod (index) {
        this.isLoading = true
        const scrollbar = document.getElementById('scrollbar')
        const graphInnerArea = document.getElementsByClassName('graph-inner-area')[0]
        if (index === this.displayMethodActive) return
        const event = index === 0 ? { event: this.$t('summary'), event_category: this.$t('seizure_status_graph'), event_label: this.$t('summary') }
                              : { event: this.$t('scroll'), event_category: this.$t('seizure_status_graph'), event_label: this.$t('scroll') }
        if (index === 0 && [6,7,8].includes(this.filterTypeActive)) {
          graphInnerArea.scrollLeft = 0
        }
        if (index !== 0 && this.displayTypeActive !== 2) {
          scrollbar.style.display = 'block'
        } else {
          scrollbar.style.display = 'none'
        }
        this.eventTracking(event)
        this.displayMethodActive = index
        this.iconSize = (index === 1 && this.displayTypeActive === 0) ? '15px' : '12px'
        await this.setChartData()
        this.updateScrollbar()
        this.isLoading = false
      },
      onFilterData(type, index) {
        if (index === this.tempFilterTypeActive) return
        this.tempFilterTypeActive = index
        switch(index) {
          case 0:
            this.tempDateFrom = moment(new Date(this.tempDateEnd)).format('YYYY/MM/DD')
            break
          case 1:
            this.tempDateFrom = moment(new Date(this.tempDateEnd)).subtract(6, 'days').format('YYYY/MM/DD')
            break
          case 2:
            this.tempDateFrom = moment(new Date(this.tempDateEnd)).subtract(1, 'months').format('YYYY/MM/DD')
            break
          case 3:
            this.tempDateFrom = moment(new Date(this.tempDateEnd)).subtract(3, 'months').format('YYYY/MM/DD')
            break
          case 4:
            this.tempDateFrom = moment(new Date(this.tempDateEnd)).subtract(6, 'months').format('YYYY/MM/DD')
            break
          case 5:
            this.tempDateFrom = moment(new Date(this.tempDateEnd)).subtract(1, 'years').format('YYYY/MM/DD')
            break
          case 6:
            this.tempDateFrom = moment(new Date(this.tempDateEnd)).subtract(3, 'years').format('YYYY/MM/DD')
            break
          case 7:
            this.tempDateFrom = moment(new Date(this.tempDateEnd)).subtract(5, 'years').format('YYYY/MM/DD')
            break
          case 8:
            this.tempDateFrom = moment(new Date(this.minDate)).format('YYYY/MM/DD')
            break
          default:
            break
        }
      },
      async onGetData() {
        if (!this.numberSeiZure && !this.defaultSeizure) {
          this.numberSeiZure = 5
        }
        this.filterTypeBeforeTimeOut = this.filterTypeActive
        this.tempDateEndBeforeTimeOut = this.dateFrom
        if (!this.isValidDate(moment(new Date(this.tempDateEnd)).format('YYYY/MM/DD'))) {
          this.isInvalidDate = true
          this.tempDateFrom = null
          return
        }
        this.filterTypeActive = this.tempFilterTypeActive
        if ([6,7,8].includes(this.filterTypeActive) ) {
          this.displayTypeActive = 0
        }
        let event = null
        switch (this.filterTypeActive) {
          case 0:
            event = { event: this.$t('display_period_setting_day'), event_category: this.$t('display_period_setting'), event_label: this.$t('one_day') }
            break
          case 1:
            event = { event: this.$t('display_period_setting_week'), event_category: this.$t('display_period_setting'), event_label: this.$t('one_week') }
            if (this.displayTypeActive === 2 || this.displayTypeActive === 1) {
              this.displayTypeActive = 0
            }
            break
          case 2:
            event = { event: this.$t('display_period_setting_month'), event_category: this.$t('display_period_setting'), event_label: this.$t('one_month') }
            if (this.displayTypeActive === 2) {
              this.displayTypeActive = 0
            }
            break
          case 3:
            event = { event: this.$t('display_period_setting_3_months'), event_category: this.$t('display_period_setting'), event_label: this.$t('three_months') }
            break
          case 4:
            event = { event: this.$t('display_period_setting_6_months'), event_category: this.$t('display_period_setting'), event_label: this.$t('six_months') }
            break
          case 5:
            event = { event: this.$t('display_period_setting_year'), event_category: this.$t('display_period_setting'), event_label: this.$t('one_year') }
            break
          case 6:
            event = { event: this.$t('display_period_setting_3_year'), event_category: this.$t('display_period_setting'), event_label: this.$t('three_year') }
            if (this.displayTypeActive === 0) {
              this.displayTypeActive = 1
            }
            break
          case 7:
            event = { event: this.$t('display_period_setting_5_year'), event_category: this.$t('display_period_setting'), event_label: this.$t('five_year') }
            if (this.displayTypeActive === 0) {
              this.displayTypeActive = 1
            }
            break
          case 8:
            event = { event: this.$t('display_period_setting_all_year'), event_category: this.$t('display_period_setting'), event_label: this.$t('all_year') }
            if (this.displayTypeActive === 0) {
              this.displayTypeActive = 1
            }
            break
          default:
            break
        }
        this.eventTracking(event)
        this.dateFrom = this.tempDateFrom
        this.dateEnd = this.tempDateEnd
        if ([2,3,4,5].includes(this.filterTypeActive)) {
          this.displayType = this.filterTypeActive !== 2 ? [this.$t('by_day'), this.$t('by_week'), this.$t('by_month')] : [this.$t('by_day'), this.$t('by_week')]
          this.isShowDisplayType = true
          document.getElementsByClassName('period-btn-pos')[0].style.display = 'block'
          document.getElementsByClassName('period-btn-pos')[0].children[0].children[0].style.display = 'block'
        } else if ([6,7,8].includes(this.filterTypeActive)) {
          this.displayType = [this.$t('by_day'), this.$t('by_week'), this.$t('by_month')]
          document.getElementsByClassName('period-btn-pos')[0].style.display = 'block'
          document.getElementsByClassName('period-btn-pos')[0].children[0].children[0].style.display = 'none'
          this.isShowDisplayType = true
        } else {
          this.isShowDisplayType = true
          document.getElementsByClassName('period-btn-pos')[0].style.display = 'none'
        }

        this.isShowDisplayMethod = [3,4,5,6,7,8].includes(this.filterTypeActive) ? true : false
        this.isLoading = true
        if (!this.$route.params.childId) {
          let params = {
            one_time_access_key: this.otpAccessToken,
            from_date: moment(new Date(this.dateFrom)).format('YYYY/MM/DD'),
            to_date: moment(new Date(this.dateEnd)).format('YYYY/MM/DD')
          }
          await this.$store.dispatch("patient/getSeizures", { params: params })
          .then( res => {})
          .catch((error) => {console.log(error)})
          await this.$store.dispatch("medicine/getMedicines", { params: params })
        } else {
          let params = {
            childId: this.$route.params.childId,
            from_date: moment(new Date(this.dateFrom)).format('YYYY/MM/DD'),
            to_date: moment(new Date(this.dateEnd)).format('YYYY/MM/DD'),
            typeOfUser: this.$store.state.auth.typeOfUser
          }
          //add property pharmacy_user_id if use is pharmacy
          if (this.$store.state.auth.typeOfUser === 'pharmacy') {
            params.pharmacy_user_id = this.$store.state.auth.doctorInfo.id
          }
          const timeoutPromise = new Promise((resolve) => {
          setTimeout(() => {
              resolve({ timeout: true });
            }, 10000);
          });

          try {
              // Make your API call using async/await
              const responsePromise = this.$store.dispatch("patient/getSeizures", { params: params })
              // Wait for either the API response or the timeout
              const result = await Promise.race([responsePromise, timeoutPromise]);
              // Check if the API call completed within the time limit
              if (result.timeout) {
                // If it took more than 20 seconds, display the alert
                this.isLoading = true
                this.$bvModal.show('modal-exceed-time')
                sessionStorage.removeItem('seizure_graph_list_date_'+this.$route.params.childId)
                sessionStorage.removeItem('seizure_graph_data_'+this.$route.params.childId)
              }
          } catch (error) {
            // Handle errors
            console.error('Error:', error);
          }
          await this.$store.dispatch("medicine/getMedicines", { params: params })
        }
        this.isLoading = false
        this.displayMethodActive = 0
        // this.displayTypeActive = 0
        this.seizureType.map((type, index) => {
        let indexFirstArr = this.seizuresTypeActive[0]
        this.onChangeSeizureType(indexFirstArr, type, false)
        })
        await this.setChartData()
        this.updateScrollbar()
        this.$bvModal.hide('modal-calendar')
        let nextDate = moment(this.dateEnd)
        switch(this.tempFilterTypeActive) {
          case 0:
            nextDate.add(1, 'days')
            break
          case 1:
            nextDate.add(6, 'days')
            break
          case 2:
            nextDate.add(1, 'months')
            break
          case 3:
            nextDate.add(3, 'months')
            break
          case 4:
            nextDate.add(6, 'months')
            break
          case 5:
            nextDate.add(1, 'years')
            break
          case 6:
            nextDate.add(3, 'years')
            break
          case 7:
            nextDate.add(5, 'years')
            break
          case 8:
            nextDate = moment(this.minDate).format('YYYY/MM/DD')
            break
          default:
            break
        }
        this.setDisableIcon(nextDate.format('YYYY/MM/DD'))
        var ul = document.querySelector('.type-btn-pos ul')
        var lastThreeLiElements = ul.querySelectorAll('li:nth-last-child(-n+3)')
        if ([6,7,8].includes(this.filterTypeActive) && this.displayTypeActive != 0) {
          lastThreeLiElements.forEach(function(li) {
            li.style.display = 'block';
          });          
        }
      },
      async setChartData() {
        this.isLoading = true
        this.resetImg()
        // set chart data
        let labels = []
        let labels2 = []
        const datasets = []
        const shortcats = this.shortcats
        let seizures = []
        let videoList = []
        let medicineList = []
        let medicineTaken = {}
        const labelDate = [
          this.$t('hour', {hour: 0}), this.$t('hour', {hour: 1}), this.$t('hour', {hour: 2}), this.$t('hour', {hour: 3}), 
          this.$t('hour', {hour: 4}), this.$t('hour', {hour: 5}), this.$t('hour', {hour: 6}), this.$t('hour', {hour: 7}), 
          this.$t('hour', {hour: 8}), this.$t('hour', {hour: 9}), this.$t('hour', {hour: 10}), this.$t('hour', {hour: 11}), 
          this.$t('hour', {hour: 12}), this.$t('hour', {hour: 13}), this.$t('hour', {hour: 14}), this.$t('hour', {hour: 15}), 
          this.$t('hour', {hour: 16}), this.$t('hour', {hour: 17}), this.$t('hour', {hour: 18}), this.$t('hour', {hour: 19}), 
          this.$t('hour', {hour: 20}), this.$t('hour', {hour: 21}), this.$t('hour', {hour: 22}), this.$t('hour', {hour: 23}),
        ]
        if(this.firstLoad) {
          var ul = document.querySelector('.type-btn-pos ul');
          var lastThreeLiElements = ul.querySelectorAll('li:nth-last-child(-n+3)');
          lastThreeLiElements.forEach(function(li) {
            li.style.display = 'none';
          });
        }
        // set labels
        if (this.filterTypeActive === 0){
          labels = labelDate
          seizures = this.seizureData
          videoList = this.seizures.video_list
          medicineList = this.seizures.seizure_medication
          if (this.medicines) {
              let items = []
              for(let i=0; i < this.medicines.length; i++) {
                if(
                  moment(this.medicines[i].medicine_start_date) <= moment(this.dateEnd)
                  && (
                    moment(this.medicines[i].medicine_end_date) >= moment(this.dateEnd)
                    || (
                      this.medicines[i].prescription_id === null 
                      && this.medicines[i].medicine_end_date === null
                      && (
                        this.medicines[i].latest_flg === 1
                        || moment(this.medicines[i-1]?.medicine_start_date) > moment(this.dateEnd)
                      )
                    )
                    || (
                      this.medicines[i].prescription_id !== null 
                      && this.medicines[i].medicine_end_date === null
                    )
                  )
                ){
                  items.push(this.medicines[i])
                }
              }
              if(items) {
                let listName = []
                items.forEach((item) => {
                  item.medicine_record.map((value) => {
                    if(listName.includes(value.medicine_name)) {
                      medicineTaken[value.medicine_name].listAmount.push(value.total_ingredient_amount)
                      // start date
                      medicineTaken[value.medicine_name].listStartDate
                        ? medicineTaken[value.medicine_name].listStartDate.push(item.medicine_start_date)
                        : medicineTaken[value.medicine_name].listStartDate = [medicineTaken[value.medicine_name].start_date, item.medicine_start_date]

                      // end date
                      medicineTaken[value.medicine_name].listEndDate
                        ? medicineTaken[value.medicine_name].listEndDate.push(item.medicine_end_date)
                        : medicineTaken[value.medicine_name].listEndDate = [medicineTaken[value.medicine_name].end_date, item.medicine_end_date]
                    }
                    else {
                      listName.push(value.medicine_name)
                      medicineTaken[value.medicine_name] = {
                        listAmount: [value.total_ingredient_amount],
                        unit: value.total_ingredient_amount > 0 ? value.ingredient_unit : '',
                        is_multi_ingredient: value.multiple_ingredient_amount,
                        start_date: item.medicine_start_date,
                        end_date: item.medicine_end_date,
                        is_external: value.is_external,
                        total_ingredient: value.total_ingredient ?? '',
                      }
                    }
                  })
                })
              }
          }
        } else {
          // get medicine taken
          let medicineTakenBetweenTwoDate = {}
          const dates = this.getListDateBetweenToDate(this.dateFrom, this.dateEnd)
          const medicineTakenByName = []
          dates.forEach((date) => {
            let items = []
            for(let i=0; i < this.medicines.length; i++) {
              if(
                moment(this.medicines[i].medicine_start_date) <= moment(date)
                && (
                  moment(this.medicines[i].medicine_end_date) >= moment(date)
                  || (
                    this.medicines[i].prescription_id === null 
                    && this.medicines[i].medicine_end_date === null
                    && (
                      this.medicines[i].latest_flg === 1
                      || moment(this.medicines[i-1]?.medicine_start_date) > moment(date)
                    )
                  )
                  || (
                    this.medicines[i].prescription_id !== null 
                    && this.medicines[i].medicine_end_date === null
                  )
                )
              ){
                items.push(this.medicines[i])
              }
            }
            if(items) {
              items.forEach((item) => {
                item.medicine_record.forEach((record) => {
                  medicineTakenByName.push({ 
                    name: record.medicine_name, 
                    date: date,
                    id: item.id,
                    ingredient_amount: record.total_ingredient_amount, 
                    unit: record.ingredient_unit ,
                    is_multi_ingredient: record.multiple_ingredient_amount,
                    is_external: record.is_external,
                    total_ingredient: record.total_ingredient ?? '',
                  })
                })
              })
            }
          })
          const medicineTakenGroupByName = _.groupBy(medicineTakenByName, function(medicine) { return medicine.name })
          for (let [key, value] of Object.entries(medicineTakenGroupByName)) {
            const medicineTakenData = value.map((item) => item.date)
            const data = this.fillMedicineTaken(medicineTakenData, dates, value)
            medicineTakenBetweenTwoDate[key] = data
          }
          // end get medicine taken

          switch(this.displayTypeActive) {
            case 0:
              for (var m = moment(this.dateFrom); m.diff(this.dateEnd, 'days') <= 0; m.add(1, 'days')) {
                const date = m.format('YYYY/M/D')
                const label = date.split('/')[2] === '1' ? date.split('/')[1] + '/' + date.split('/')[2] : date.split('/')[2]
                labels.push(label)
                labels2.push(m.format('YYYY/MM/DD'))
              }
              seizures = this.seizureData
              videoList = this.seizures.video_list
              medicineList = this.seizures.seizure_medication
              medicineTaken = medicineTakenBetweenTwoDate
              break
            case 1:
              for (var m = moment(this.dateFrom); m.diff(this.dateEnd, 'days') <= 0; m.add(7, 'days')) {
                const startWeekDay = m.format('YYYY/M/D')
                labels.push(startWeekDay.split('/')[1] + '/' + startWeekDay.split('/')[2] + '~')
                labels2.push(m.clone().format('YYYY/MM/DD') + " ~ " + m.clone().add(6, 'days').format('DD'))
              }
              this.seizureData.forEach((seizure) => {
                const data = _.chunk(seizure.data, 7)
                const chunkCount = data.map((item) => _.sum(item))
                seizures.push({
                  shortcat_index: seizure.shortcat_index,
                  data: chunkCount
                })
              })
              const videoListGroup = _.chunk(this.seizures.video_list, 7)
              const medicineListGroup = _.chunk(this.seizures.seizure_medication, 7)
              videoList = videoListGroup.map((item) => item.reduce((a,b) => a || b))
              medicineList = medicineListGroup.map((item) => item.reduce((a,b) => a || b))
              medicineTaken = medicineTakenBetweenTwoDate
              break
            case 2:
              let dateFrom = new Date(this.dateFrom)
              dateFrom.setDate(1)
              let dateEnd = new Date(this.dateEnd)
              dateEnd.setDate(1)
              let monthList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
              while (dateFrom <= dateEnd)
              {
                labels.push(this.$t('month_month', {month: monthList[dateFrom.getMonth()]}))
                labels2.push(dateFrom.getFullYear() + "/" + monthList[dateFrom.getMonth()].padStart(2, '0'))
                dateFrom.setMonth(dateFrom.getMonth() + 1)
              }
              this.seizureData.forEach((seizure) => {
                const arrData = []
                dates.forEach((date, index) => {
                  arrData.push({
                    date: date,
                    count: seizure.data[index]
                  })
                })
                const monthData = _.groupBy(arrData, function(item) { return item.date.slice(0,7) })
                const chunkCount = Object.values(monthData).map((item) => _.sumBy(item, function(o) { return o.count }))
                seizures.push({
                  shortcat_index: seizure.shortcat_index,
                  data: chunkCount
                })
              })
              const arrList = []
              dates.forEach((date, index) => {
                arrList.push({
                  date: date,
                  video: this.seizures.video_list[index],
                  medicine: this.seizures.seizure_medication[index]
                })
              })
              const monthData = _.groupBy(arrList, function(item) { return item.date.slice(0,7) })
              videoList = Object.values(monthData).map((item) => {
                const videos = item.map((data) => data.video)
                if (item.length > 1) return videos.reduce((a,b) => a || b)
                else return videos[0]
              })
              medicineList = Object.values(monthData).map((item) => {
                const medicines = item.map((data) => data.medicine)
                if (item.length > 1) return medicines.reduce((a,b) => a || b)
                else return medicines[0]
              })
              medicineTaken = medicineTakenBetweenTwoDate
              break
            default:
              break
          }
        }
          defaultDatasets.forEach((item, index) => {
            if (shortcats.map((item) => item.shortcat_index).includes(index)) {
              let dataIndex = _.findIndex(seizures, function(seizure) { return seizure.shortcat_index === index })
              if (dataIndex !== -1) item.data = seizures[dataIndex].data
              else item.data = _.fill(Array(this.chartData.labels.length), 0)
              datasets.push(item)
            }
            const seizureNull = 6
            if (index === seizureNull) {
              let dataOther = _.findIndex(seizures, function(seizure) { return seizure.shortcat_index === null })
              if (dataOther !== -1) item.data = seizures[dataOther].data
              else item.data = _.fill(Array(this.chartData.labels.length), 0)
              datasets.push(item)
            }
          })
        // show info
        const chart = this.$refs.chart.$data._chart
        if (this.displayMethodActive === 0) {
          this.tableWidth = parseInt(document.getElementById("bar-chart").style.width, 10)
          let countLoop = 0
          while (this.tableWidth <= 0 && countLoop++ < 20) {
            await new Promise(resolve => setTimeout(resolve, 100))
            this.tableWidth = parseInt(document.getElementById("bar-chart").style.width, 10)
            if(this.tableWidth <= 0 && countLoop == 20) {
              //50: padding left + padding right + scroll width
              let otherWidth = (document.getElementById('patient-detail-area') ? document.getElementById('patient-detail-area').offsetWidth : document.getElementById('patient-area').offsetWidth) - 50
              this.tableWidth = parseInt(otherWidth, 10)
            }
          }
        } else {
          const parentChartNode = chart.canvas.parentNode
          if (this.displayMethodActive === 1 && this.baseWidth < labels.length * this.widthChartDesktop) {
            const setWidthChart = this.setWidthDevice ? labels.length * this.widthChartIpad : labels.length * this.widthChartDesktop
            parentChartNode.style.width = setWidthChart
            this.tableWidth = setWidthChart
          } else {
            parentChartNode.style.width = this.baseWidth
            this.tableWidth = this.baseWidth
          }
        }
        //show video info
        let iconSize = this.iconSize
        let widthList = correctColumnWidthData(this.tableWidth - 100, videoList.length);
        this.videosData = videoList
        this.widthList = widthList
        //show medicine info
        let tableSeizureMedication = document.getElementById("show-seizure-medication")
        tableSeizureMedication.innerHTML = ''
        // var width = 100/medicineList.length
        var newRow = "<tr>"
        medicineList.forEach(function(item, index, arr) {
          if (item) {
            newRow += `<th style="text-align: center; max-width:${widthList[index]}px; min-width:20px;width:${widthList[index]}px;"><span class="icon_suppository_patient" style="width:${iconSize}; height:${iconSize};"></span></th>`
          } else {
            newRow += `<th style="width:${widthList[index]}px;max-width:${widthList[index]}px; min-width:20px;"></th>`
          }
        })
        newRow += "</tr>"
        tableSeizureMedication.insertAdjacentHTML('beforeend', newRow)
        makeMedicineBarForMedicineAmount(medicineTaken, this.filterTypeActive, this.tableWidth, this.medicineColors, false)
        // end medicine taken
        this.chartData.labels = labels
        this.chartData.temp_labels = getMonthBetweenDate(this.dateFrom, this.dateEnd)
        this.chartData.labels2 = labels2
        this.chartData.datasets = datasets
        this.chartData.scroll = this.displayMethodActive
        this.pdfList = {
          videoList,
          medicineList,
          medicineTaken,
          labels,
          dataSeizure: seizures
        }
        if (!this.firstLoad && !this.defaultSeizure) {
          chart.config.options.scales.yAxes[0].ticks.max = parseInt(this.numberSeiZure);
        } else if (this.defaultSeizure && chart.config.options.scales.yAxes[0].ticks.max){
          chart.options = {
            animation: false,
            normalized: true,
            showLine: false,
            scales: {
              xAxes: [{
                stacked: true,
                gridLines: {
                  color: "rgba(0, 0, 0, 0)"
                }
              }],
              yAxes: [{
                stacked: true,
                afterFit: function(scaleInstance) {
                  scaleInstance.width = 100
                },
                ticks: {
                  beginAtZero: true,
                  precision: 0,
                  suggestedMax: 5
                }
              }]
            },
            tooltips: {
              mode: 'index',
              position: 'custom',
              callbacks: {
                label: (tooltipItem, data) => {
                  return this.formatLabelInTooltip(tooltipItem, data)
                },
                labelTextColor: (context) => {
                  return '#333333'
                },
                title: (tooltipItem, data) => {
                  return this.formatTitleTooltips(tooltipItem, data)
                },
              },
              backgroundColor: '#fff',
              titleFontColor: '#333333',
              titleFontStyle: 'normal',
              borderColor: '#FF86A0',
              borderWidth: 1,
              bodySpacing: 6,
              xPadding: 10,
              yPadding: 10,
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            layout: {
              padding: {
                bottom: 15,
                right: 20,
              },
            },
            onHover : (event, activeElements) => {
              if (activeElements.length > 0) {
                if (this.imageCanvas !== '' ) {
                  setTimeout(() => {
                    this.imageCanvas = ''
                  }, 200);
                }
              }
            }
          }
        }
        chart.update()
        setTimeout(() => {
          this.convertCanvasToImage()
        }, 1000);
        this.isLoading = false
      },
      getListDateBetweenToDate(from, to) {
        const dates = []
        for (var m = moment(from); m.diff(to, 'days') <= 0; m.add(1, 'days')) {
          const date = m.format('YYYY/MM/DD')
          dates.push(date)
        }
        return dates
      },
      fillMedicineTaken(data, listDate, value) {
        const arrDate = listDate.slice()
        let listAmountWithId = []
        let listAmount = []
        let unit = ''
        let medicine_start_date = ''
        let medicine_end_date = ''
        let is_multi_ingredient = false
        let is_external = false
        let total_ingredient = ''
        arrDate.forEach((date, index) => {
          if (data.includes(date)) {
            let amountOneDay = []
            value.forEach(item => {
              if(item?.date == date && !listAmountWithId.some(el => item.ingredient_amount == el.amount && item.id == el.id)) {
                listAmount.push(item.ingredient_amount)
                this.medicines.forEach(e => {
                  if (item.id == e.id) {
                    medicine_start_date = e.medicine_start_date
                    medicine_end_date = e.medicine_end_date
                    is_external = item.is_external
                  }
                })
                listAmountWithId.push({amount: item.ingredient_amount, id: item.id, medicine_start_date: medicine_start_date, medicine_end_date: medicine_end_date})
              }
              (item?.date == date) ? amountOneDay.push({amount: item.ingredient_amount, id: item.id}) : '';
              (unit == '' && item?.unit) ? unit = item.unit : '';
              (is_multi_ingredient == false && item?.is_multi_ingredient) ? is_multi_ingredient = item.is_multi_ingredient : '';
              (item.total_ingredient) ? total_ingredient = item.total_ingredient : ''
            })
            arrDate[index] = amountOneDay
          }
          else {
            arrDate[index] = null
          }
        })
        return {
          data: arrDate,
          listAmount: listAmount,
          listAmountWithId: listAmountWithId,
          unit: unit,
          is_multi_ingredient: is_multi_ingredient,
          is_external: is_external,
          total_ingredient: total_ingredient
        }
      },
      onShowCalendar() {
        this.$bvModal.show('modal-calendar')
        setTimeout(this.moveToSelectedDate, 0)
        const event = { event: '表示期間設定', event_category: '患者情報', event_label: '表示期間設定' }
        this.eventTracking(event)
        document.getElementById('scrollbar').style.display = 'none'
      },
      async moveToSelectedDate() {
        const calendar = this.$refs.calendar
        if(!calendar) return
        await calendar.move(new Date(this.tempDateEnd))
      },
      setChoosenDateHighlight() {
        const isToday = this.tempDateEnd === moment(new Date()).format('YYYY/MM/DD')
        const attr = this.datePickerAttr.slice()
        attr[1].dates = (isToday || this.isInvalidDate)? null : new Date(this.tempDateEnd)
        this.datePickerAttr = attr
        this.moveToSelectedDate()
      },
      setToday() {
        this.tempDateEnd = today
      },
      isValidDate(date) {
        if(!date) return false
        const datePattern = /^(\d{4})(\/)(\d{2})(\/)(\d{2})$/
        const dtArray = date.match(datePattern)

        if (!dtArray) return false
        const dtMonth = dtArray[3]
        const dtDay= dtArray[5]
        const dtYear = dtArray[1]
        if (dtMonth < 1 || dtMonth > 12) return false
        else if (dtDay < 1 || dtDay > 31) return false
        else if ([4, 6, 9, 11].includes(dtMonth) && dtDay === 31) return false
        else if (dtMonth == 2)
        {
          const isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0))
          if (dtDay > 29 || (dtDay === 29 && !isleap)) return false
        }
        else if (moment(new Date()).format('YYYY/MM/DD') < moment(new Date(date)).format('YYYY/MM/DD')) return false
        return true
      },
      onHideCalendar() {
        this.tempDateEnd = this.dateEnd
        this.tempDateFrom = this.dateFrom
        this.tempFilterTypeActive = this.filterTypeActive
        this.$bvModal.hide('modal-calendar')
      },
      dayClicked(day) {
        if (this.tempFilterTypeActive === 8) {
          this.tempDateEnd = moment(new Date()).format('YYYY/MM/DD')
        } else {
          if (moment(new Date()).format('YYYY/MM/DD') < moment(new Date(day.id)).format('YYYY/MM/DD')) return
          this.tempDateEnd = moment(new Date(day.id)).format('YYYY/MM/DD')
        }
      },
      onResize({ width, height }) {
        this.tableWidth = width
        let widthList = correctColumnWidthData(this.tableWidth - 100, this.videosData.length);
        this.widthList = widthList
        this.pdfList?.medicineTaken ? makeMedicineBarForMedicineAmount(this.pdfList.medicineTaken, this.filterTypeActive, this.tableWidth, this.medicineColors, false) : ''
      },
      getVideoByDate(videoList){
        const videos = videoList.filter((video) => {
        const date = moment(new Date(video.create_date)).format('YYYY/MM/DD')
          return date === this.selectedDate
        })
        return videos
      },
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
        let maxSlide = this.videosShow.length;
        let currentSlide = this.slide + 1;
        let btnPrev = document.querySelectorAll(".carousel-control-prev")[0]
        let btnNext = document.querySelectorAll(".carousel-control-next")[0]
        if(currentSlide === maxSlide){
          btnNext.style.display = "none"
          btnPrev.style.display = 'block'
        }
        else if(currentSlide === 1){
          btnPrev.style.display = "none"
          btnNext.style.display = "block"
        }
        else {
          btnNext.style.display = 'block'
          btnPrev.style.display = 'block'
        }
      },
       closeModalListVideo() {
        this.isPlaying = false
        this.$bvModal.hide('video-list-modal-in-seizure-graph')
      },
      onModalSlideHidden () {
        this.activePage = 'graph'
      },
      OnModalShow() {
        this.slide = 0;
      },
      onPlayVideoSlider(index) {
        $(this.$refs['movie-icon' + index]).hide();
        let videosPlayer = this.$refs.videoPlayerSlider
        for (let i = 0; i < videosPlayer.length; i++) {
          if(i === index){
            videosPlayer[i].children[0].play()
            videosPlayer[i].children[0].controls = true
            videosPlayer[i].children[0].controlsList = "noplaybackrate nodownload"
            videosPlayer[i].children[0].disablePictureInPicture = true;
          }
        }
        const event = {
          event: this.$t('video'),
          event_category: this.$t('video'),
          event_label: this.$t('reproduction')
        }
        this.eventTracking(event)
      },
      resetImg() {
        this.imageCanvas = ''
      },
      async onGetDataChart(type, index) {
        if (!this.numberSeiZure && !this.defaultSeizure) {
          this.numberSeiZure = 5
        }
        this.filterTypeBeforeTimeOut = this.filterTypeActive
        this.tempDateEndBeforeTimeOut = this.dateFrom
        this.isLoading = true
        this.firstLoad = false
        if ([6,7,8].includes(index) && this.displayTypeActive === 0) {
          this.displayTypeActive = 1
        }
        this.resetImg()
        this.onFilterData(type, index)
        this.dateFrom = index === 8 && this.minDate ? moment(new Date(this.minDate)).format('YYYY/MM/DD') : this.tempDateFrom
        this.dateEnd = index === 8 ? moment(new Date()).format('YYYY/MM/DD') : this.tempDateEnd
        this.onGetDataAPI(true)
        if (index <=2) {
          this.displayMethodActive = 0
          document.getElementById('scrollbar').style.display = 'none'
        }
        var ul = document.querySelector('.type-btn-pos ul');
        // Select the last three <li> elements
        var lastThreeLiElements = ul.querySelectorAll('li:nth-last-child(-n+3)');
        if (index === 1) this.displayTypeActive = 1
        if (index === 2 && this.displayTypeActive === 2) this.displayTypeActive = 1
        if (index === 0 || this.displayTypeActive === 0) {
          // Hide the last three <li> elements
            lastThreeLiElements.forEach(function(li) {
              li.style.display = 'none';
            });
        } else {
          // Hide the last three <li> elements
          lastThreeLiElements.forEach(function(li) {
            li.style.display = 'block';
          });
        }
        switch(index) {
          case 0:
            const addOneDate = moment(this.tempDateEnd).add(1, 'days').format('YYYY/MM/DD')
            this.setDisableIcon(addOneDate)
            break
          case 1:
            const addOneWeek = moment(this.tempDateEnd).add(6, 'days').format('YYYY/MM/DD')
            this.setDisableIcon(addOneWeek)
            if (this.displayTypeActive === 2 || this.displayTypeActive === 1) {
              this.displayTypeActive = 0
            }
            break
          case 2:
            const addOneMonth = moment(this.tempDateEnd).add(1, 'months').format('YYYY/MM/DD')
            this.setDisableIcon(addOneMonth)
            if (this.displayTypeActive === 2) {
              this.displayTypeActive = 0
            }
            break
          case 3:
            const addThreeMonth = moment(this.tempDateEnd).add(3, 'months').format('YYYY/MM/DD')
            this.setDisableIcon(addThreeMonth)
            break
          case 4:
            const addSixMonth = moment(this.tempDateEnd).add(6, 'months').format('YYYY/MM/DD')
            this.setDisableIcon(addSixMonth)
            break
          case 5:
            const addOneYear = moment(this.tempDateEnd).add(1, 'years').format('YYYY/MM/DD')
            this.setDisableIcon(addOneYear)
            break
          case 6:
            const add3Year = moment(this.tempDateEnd).add(3, 'years').format('YYYY/MM/DD')
            this.setDisableIcon(add3Year)
            break
          case 7:
            const add5Year = moment(this.tempDateEnd).add(5, 'years').format('YYYY/MM/DD')
            this.setDisableIcon(add5Year)
            break
          case 8:
            const allYear = moment(this.minDate).format('YYYY/MM/DD')
            this.setDisableIcon(allYear)
            break
          default:
            break
        }
        this.updateScrollbar()
      },
      async onGetDataChartPrev(index) {
        this.resetImg()
        const datePrev = this.tempDateFrom
        switch(index) {
          case 0:
            this.tempDateFrom = moment(new Date(this.tempDateFrom)).subtract(1, 'days').format('YYYY/MM/DD')
            break
          case 1:
            this.tempDateFrom = moment(new Date(this.tempDateFrom)).subtract(6, 'days').format('YYYY/MM/DD')
            break
          case 2:
            this.tempDateFrom = moment(new Date(this.tempDateFrom)).subtract(1, 'months').format('YYYY/MM/DD')
            break
          case 3:
            this.tempDateFrom = moment(new Date(this.tempDateFrom)).subtract(3, 'months').format('YYYY/MM/DD')
            break
          case 4:
            this.tempDateFrom = moment(new Date(this.tempDateFrom)).subtract(6, 'months').format('YYYY/MM/DD')
            break
          case 5:
            this.tempDateFrom = moment(new Date(this.tempDateFrom)).subtract(1, 'years').format('YYYY/MM/DD')
            break
          case 6:
            this.tempDateFrom = moment(new Date(this.tempDateFrom)).subtract(3, 'years').format('YYYY/MM/DD')
            break
          case 7:
            this.tempDateFrom = moment(new Date(this.tempDateFrom)).subtract(5, 'years').format('YYYY/MM/DD')
            break
          default:
            break
        }

        this.tempDateEnd = index !== 0 ? datePrev : this.tempDateFrom
        this.dateFrom = this.tempDateFrom
        this.dateEnd = index !== 0 ? datePrev : this.tempDateFrom
        this.onGetDataAPI(true)
      },
      async onGetDataChartNext(index) {
        this.resetImg()
        const dateNext = this.tempDateEnd
        switch(index) {
          case 0:
            this.tempDateEnd = moment(new Date(this.tempDateEnd)).add(1, 'days').format('YYYY/MM/DD')
            break
          case 1:
            this.tempDateEnd = moment(new Date(this.tempDateEnd)).add(6, 'days').format('YYYY/MM/DD')
            break
          case 2:
            this.tempDateEnd = moment(new Date(this.tempDateEnd)).add(1, 'months').format('YYYY/MM/DD')
            break
          case 3:
            this.tempDateEnd = moment(new Date(this.tempDateEnd)).add(3, 'months').format('YYYY/MM/DD')
            break
          case 4:
            this.tempDateEnd = moment(new Date(this.tempDateEnd)).add(6, 'months').format('YYYY/MM/DD')
            break
          case 5:
            this.tempDateEnd = moment(new Date(this.tempDateEnd)).add(1, 'years').format('YYYY/MM/DD')
            break
          case 6:
            this.tempDateEnd = moment(new Date(this.tempDateEnd)).add(3, 'years').format('YYYY/MM/DD')
            break
          case 7:
            this.tempDateEnd = moment(new Date(this.tempDateEnd)).add(5, 'years').format('YYYY/MM/DD')
            break
          default:
            break
        }
        this.dateFrom = index !== 0 ? dateNext : this.tempDateEnd
        this.dateEnd = this.tempDateEnd
        this.onGetDataAPI(true)
      },
      async onGetDataAPI(item) {
        if ([2,3,4,5].includes(this.tempFilterTypeActive)) {
          this.displayType = this.tempFilterTypeActive !== 2 ? [this.$t('by_day'), this.$t('by_week'), this.$t('by_month')] : [this.$t('by_day'), this.$t('by_week')]
          document.getElementsByClassName('period-btn-pos')[0].style.display = 'block'
          document.getElementsByClassName('period-btn-pos')[0].children[0].children[0].style.display = 'block'
          this.isShowDisplayType = true
        } else if ([6,7,8].includes(this.tempFilterTypeActive)) {
          this.displayType = [this.$t('by_day'), this.$t('by_week'), this.$t('by_month')]
          document.getElementsByClassName('period-btn-pos')[0].style.display = 'block'
          document.getElementsByClassName('period-btn-pos')[0].children[0].children[0].style.display = 'none'
          this.isShowDisplayType = true
        } else {
          this.isShowDisplayType = true
          document.getElementsByClassName('period-btn-pos')[0].style.display = 'none'
        }

        this.isShowDisplayMethod = [3,4,5,6,7,8].includes(this.tempFilterTypeActive) ? true : false 
        this.isLoading = true
        if (!this.$route.params.childId) {
          let params = {
            one_time_access_key: this.otpAccessToken,
            from_date: moment(new Date(this.dateFrom)).format('YYYY/MM/DD'),
            to_date: moment(new Date(this.dateEnd)).format('YYYY/MM/DD')
          }
          await this.$store.dispatch("patient/getSeizures", { params: params })
          await this.$store.dispatch("medicine/getMedicines", { params: params })
          .then( res => {})
          .catch((error) => {console.log(error)})
        } else {
          let params = {
            childId: this.$route.params.childId,
            from_date: moment(new Date(this.dateFrom)).format('YYYY/MM/DD'),
            to_date: moment(new Date(this.dateEnd)).format('YYYY/MM/DD'),
            typeOfUser: this.$store.state.auth.typeOfUser
          }
          //add property pharmacy_user_id if use is pharmacy
          if (this.$store.state.auth.typeOfUser === 'pharmacy') {
            params.pharmacy_user_id = this.$store.state.auth.doctorInfo.id
          }
          const timeoutPromise = new Promise((resolve) => {
          setTimeout(() => {
                resolve({ timeout: true });
            }, 10000);
          });

          try {
              // Make your API call using async/await
              const responsePromise = this.$store.dispatch("patient/getSeizures", { params: params })
              // Wait for either the API response or the timeout
              const result = await Promise.race([responsePromise, timeoutPromise]);
              // Check if the API call completed within the time limit
              if (result.timeout) {
                // If it took more than 10 seconds, display the alert and reload the page
                this.$bvModal.show('modal-exceed-time')
                sessionStorage.removeItem('seizure_graph_list_date_'+this.$route.params.childId)
                sessionStorage.removeItem('seizure_graph_data_'+this.$route.params.childId)
              }
          } catch (error) {
            // Handle errors
            console.error('Error:', error);
          }
          await this.$store.dispatch("medicine/getMedicines", { params: params })
          .then( res => {})
          .catch((error) => {console.log(error)})
        }
        this.isLoading = false
        // if (!item) {
        //   this.displayMethodActive = 0
        //   this.displayTypeActive = 0
        // }
        if (this.seizuresTypeActive.length !== 0) {
          let indexFirstArr = this.seizuresTypeActive[0]
          this.seizureType.map((type, index) => {
            this.onChangeSeizureType(indexFirstArr, type, false)
          })
        }
        // this.seizureType.map((type, index) => {
        //   item ? this.onChangeSeizureType(this.seizureTypeActive, type) :
        //   this.onChangeSeizureType(0, type)
        // })
        this.filterTypeActive = this.tempFilterTypeActive
        await this.setChartData()
        this.updateScrollbar()
      },
      setDisableIcon(date) {
        if (this.filterTypeActive === 8) {
          this.displayIconNextDate = false
        } else {
          date > today ? this.displayIconNextDate = false : this.displayIconNextDate = true
        }
      },
      setLoading(val) {
        this.isLoading = val
      },
      trackingChangeSeizureType(type) {
        let event = null
        switch (type) {
          case 0:
            event = { event: this.$t('all_types_of_seizures'), event_category: this.$t('seizure_type'), event_label: this.$t('all__2c') }
            break
          case 1:
            event = { event: this.$t('seizures_type_seizures_a'), event_category: this.$t('seizure_type'), event_label: this.$t('seizures_a') }
            break
          case 2:
            event = { event: this.$t('seizures_type_seizures_b'), event_category: this.$t('seizure_type'), event_label: this.$t('seizures_b') }
            break
          case 3:
            event = { event: this.$t('seizures_type_seizures_c'), event_category: this.$t('seizure_type'), event_label: this.$t('seizures_c') }
            break
          case 4:
            event = { event: this.$t('seizures_type_seizures_d'), event_category: this.$t('seizure_type'), event_label: this.$t('seizures_d') }
            break
          case 5:
            event = { event: this.$t('seizures_type_seizures_e'), event_category: this.$t('seizure_type'), event_label: this.$t('seizures_e') }
            break
          case 6:
            event = { event: this.$t('seizures_type_seizures_f'), event_category: this.$t('seizure_type'), event_label: this.$t('seizures_f') }
            break
          case 7:
            event = { event: this.$t('seizures_type_and_others'), event_category: this.$t('seizure_type'), event_label: this.$t('others') }
            break
          default:
            break
        }
        this.eventTracking(event)
      },
      convertCanvasToImage() {
        var canvas = document.getElementById("bar-chart")
        this.imageCanvas = canvas.toDataURL()
      },
      formatLabelInTooltip(tooltipItem, data) {
        if (tooltipItem.datasetIndex === this.tempStartDatasetIndex) this.tempValueInTooltips = 0
        var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]

        var tempNumber = parseInt(this.numberSeiZure) - parseInt(this.tempValueInTooltips)
        if (value === 0 || !this.defaultSeizure && this.numberSeiZure !== null && tempNumber <= 0) {
          return false
        }

        if (!this.defaultSeizure && this.numberSeiZure !== null && value > tempNumber) {
          if (value > (tempNumber < 0 ? -tempNumber : tempNumber)) {
            value -= value - (tempNumber < 0 ? -tempNumber : tempNumber)
          }
        }
        this.tempValueInTooltips += value
        let indexShortCatLabel = this.legends[tooltipItem.datasetIndex].index 
        let label = (indexShortCatLabel !== null ? this.shortcatLabel[indexShortCatLabel] + ' : ' : '') + (this.legends[tooltipItem.datasetIndex].name !== null ? this.legends[tooltipItem.datasetIndex].name + ' : ' : '') + value + this.$t('time') + (this.$t('__locale') === 'en' && value > 1 ? 's' : '')
        return "  " + label
      },
      formatTitleTooltips(tooltipItem, data) {
        let labelIndex = tooltipItem[0].index
        let total = 0
        let dateSets = data.datasets
        dateSets.forEach(item => {
          if (!isNaN(item.data[labelIndex])) {
            total += item.data[labelIndex]
          }
        })
        // if (!this.defaultSeizure && this.numberSeiZure !== null && total > this.numberSeiZure)
        //   total = this.numberSeiZure
        let dates = ''
        if (this.dateFrom === this.dateEnd) dates = this.dateFrom 
        else dates = data.labels2[labelIndex]
        return dates + "\n" + this.$t('total') + " : " + total + this.$t('time') + (this.$t('__locale') === 'en' && total > 1 ? 's' : '')
      },
      handleModal() {
        this.$bvModal.hide('modal-exceed-time')
        this.filterTypeActive = this.tempFilterTypeActive = this.filterTypeBeforeTimeOut
        this.dateFrom = this.tempDateEndBeforeTimeOut
        this.onGetDataAPI(true)
      }
    },
    watch: {
      tempDateEnd: function (val) {
        if (!val) {
          this.isInvalidDate = true
          this.dateError = this.$t('please_select_the_date')
        }
        if (!this.isValidDate(val)) {
          this.isInvalidDate = true
          this.dateError = this.$t('cannot_specify_the_entered_date')
          this.tempDateFrom = null
        } else {
          this.isInvalidDate = false
          this.dateError = ''
          switch(this.tempFilterTypeActive) {
            case 0:
              const addOneDate = moment(val).add(1, 'days').format('YYYY/MM/DD')
              this.setDisableIcon(addOneDate)
              this.tempDateFrom = moment(val).format('YYYY/MM/DD')
              break
            case 1:
              const addOneWeek = moment(val).add(6, 'days').format('YYYY/MM/DD')
              this.setDisableIcon(addOneWeek)
              this.tempDateFrom = moment(val).subtract(6, 'days').format('YYYY/MM/DD')
              break
            case 2:
              const addOneMonth = moment(val).add(1, 'months').format('YYYY/MM/DD')
              this.setDisableIcon(addOneMonth)
              this.tempDateFrom = moment(val).subtract(1, 'months').format('YYYY/MM/DD')
              break
            case 3:
              const addThreeMonth = moment(val).add(3, 'months').format('YYYY/MM/DD')
              this.setDisableIcon(addThreeMonth)
              this.tempDateFrom = moment(val).subtract(3, 'months').format('YYYY/MM/DD')
              break
            case 4:
              const addSixMonth = moment(val).add(6, 'months').format('YYYY/MM/DD')
              this.setDisableIcon(addSixMonth)
              this.tempDateFrom = moment(val).subtract(6, 'months').format('YYYY/MM/DD')
              break
            case 5:
              const addOneYear = moment(val).add(1, 'years').format('YYYY/MM/DD')
              this.setDisableIcon(addOneYear)
              this.tempDateFrom = moment(val).subtract(1, 'years').format('YYYY/MM/DD')
              break
            case 6:
              const add3Year = moment(val).add(3, 'years').format('YYYY/MM/DD')
              this.setDisableIcon(add3Year)
              this.tempDateFrom = moment(val).subtract(3, 'years').format('YYYY/MM/DD')
              break
            case 7:
              const add5Year = moment(val).add(5, 'years').format('YYYY/MM/DD')
              this.setDisableIcon(add5Year)
              this.tempDateFrom = moment(val).subtract(5, 'years').format('YYYY/MM/DD')
              break
            case 8:
              const allYear = moment(this.minDate).format('YYYY/MM/DD')
              this.setDisableIcon(allYear)
              this.tempDateFrom = moment(this.minDate).format('YYYY/MM/DD')
              break
            default:
              break
          }
          this.tempDateEnd = val
          this.setChoosenDateHighlight()
        }
      },
      activePage() {
        this.videosShow = this.getVideoByDate(this.videos)
        if(this.activePage === 'video-slider'){
          this.$bvModal.show('video-list-modal-in-seizure-graph')
        }
      },
      isExportChartPDF() {
        if(this.isExportChartPDF) {
          this.exportPDF()
        }
      }
    }
  }
</script>
    
<style lang="css">
  .circleWithScoll {
    height: 10px;
    width: 10px;
    background-color: rgb(255,142,161);
    border-radius: 50%;
    display: inline-block;
    color: white;
  }

  .icon_suppository_patient {
    background:url(../../../common/img/icon_medication_status.png) no-repeat;
    background-size: 15px 15px;
    padding: 0px 0px 0px 15px;
  }

  .chart-legend li span{
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 5px;
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(208, 201, 201);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgb(208, 201, 201);
  }
  #main-contents #m-right-col .inner-graph-content .graph-area .graph-btn-pos li .disable {
    font-size: 1.0rem;
    text-align: center;
    box-sizing: border-box;
    background:gray;
    border-radius: 20px;
    float: left;
    padding: 0 20px;
  }
  #main-contents #m-right-col .inner-graph-content .graph-area .graph-btn-pos li .disable a {
      text-decoration: none;
      color: #ffffff;
      display: block;
      width: 100%;
      padding: 10px 0;
  }

  .vc-bg-pink-600, .todayHighlight {
    background-color: #fdf2f2!important;
  }

  .vc-bg-yellow-600, .chooseDateHighlight {
    background-color: #fffa90 !important;
  }

  .chooseDateHighlight, .todayHighlight {
    color: #000000 !important;
  }

  .date_val::-webkit-inner-spin-button,
  .date_val::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
  }

  .vc-border-2 {
    border-width: 0px;
  }

  .vc-text-red-900 {
    color: #ff0000!important;
  }

  .vc-text-blue-900 {
    color: #0080ff!important;
  }

  .vc-weekday {
    color: #333333;
    font-weight: bold;
  }

  .tooltip.b-tooltip-danger .tooltip-inner {
    background-color: #ff8ea1 !important;
    max-width: 500px !important;
    width: 400px !important;
  }

  .tooltip.b-tooltip-danger.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^="top"] .arrow::before {
    border-top-color: #ff8ea1 !important;
  }

  .c-date-txt {
    padding-left: 20px;
    padding-bottom: 10px;
    color: #ff0000;
    font-size: 0.8rem;
  }

  .vc-title-layout {
    padding: .2em 0;
    border: 1px solid #FDF2F2;
    background: #ff8ea1;
    color: #ffffff;
    font-weight: bold;
  }

  .vc-title {
    color: #ffffff;
  }
  .container-type-seizure{
    overflow-x: scroll;
    overflow-y: hidden;
    max-width: 100%;
  }
  .container-type-seizure::-webkit-scrollbar {
    display: none;
  }
  .has-tooltip {
    font-size: 0.8rem;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .has-tooltip span {
    display: none;
    color: #000;
    text-decoration: none;
    padding: 3px;
  }
  .has-tooltip:hover span {
    max-width: 300px;
    min-width: 300px;
    display: inline-block;
    position: absolute;
    background-color: #FFF;
    border: 1px ridge #FF86A0;
    margin: -40px 0px;
    height: 80px;
    top: -5px;
    left: 20%;
    right: 10%;
    border-radius: 10px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
  }
  .has-tooltip span::before {
    content: " ";
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 40px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #FF86A0 transparent transparent transparent;
  }
  .has-tooltip span::after {
    content: " ";
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 39px;
    margin-left: -2px;
    border-width: 3px;
    border-style: solid;
    border-color: #FFF transparent transparent transparent;
  }
  .tooltip-for-medicine-taken {
    z-index: 10;
  }
  .show-medication-taken tr{
    height: 22px;
  }
  #scrollbar {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    /*set background color to transparent, to remove the blue line on top of the scrollbar*/
    position: absolute;
    top: 400px;
    display: none;
    height: 15px !important;
  }
  #innerScrollbar {
    height: 1px;
    line-height: 1px;
    font-size: 1px;
    visibility: hidden;
    background-color: yellow;
  }
  .graph-type-area {
    position: relative;
  }
  .icon-checkbox-uncheck {
    background:url(../../../common/img/icon_checkbox_uncheck.png) no-repeat;
    background-size: 15px 15px;
    margin-left: 5px;
    padding: 2px 0px 2px 20px;
  }

  .icon-checkbox-checked {
    background:url(../../../common/img/icon_checkbox_checked.png) no-repeat;
    background-size: 15px 15px;
    margin-left: 5px;
    padding: 2px 0px 2px 20px;
  }

  .btn-type-all {
    font-size: 0.8rem;
    text-align: center;
    box-sizing: border-box;
    border-radius: 20px;
    padding: 0 10px;
    border: 1px solid #FF86A0;
  }

  .btn-type-all:hover {
    background: #fdf2f2;
  }

  .btn-type-all a {
    text-decoration: none;
    color: #FF86A0;
    display: block;
    width: 100%;
    padding: 5px 0;
  }

  .btn-type-all-active a p span{
    color: #ffffff;
  }

  .btn-type-all-active {
    font-size: 0.8rem;
    text-align: center;
    box-sizing: border-box;
    background: #FF86A0;
    border-radius: 20px;
    padding: 1px 11px;
  }

  .btn-type-all-active:hover {
    opacity: 0.8;
  }

  .btn-type-all-active a {
    text-decoration: none;
    color: #666666;
    display: block;
    width: 100%;
    padding: 5px 0;
  }

  .btn-type-all-active a p span{
    color: #ffffff;
  }
</style>
